import * as React from "react";

interface IProps {
  fill?: string;
}

// tslint:disable:max-line-length
const IconTreatments = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="20"
      viewBox="0 0 19 20"
    >
      <defs>
        <path id="b" d="M0 0h1440v56H0z" />
        <filter
          id="a"
          width="101.4%"
          height="135.7%"
          x="-.7%"
          y="-14.3%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="3"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0985903533 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-320 -18)">
          <use fill="#000" filter="url(#a)" />
          <use fill="#FFF" />
        </g>
        <path d="M-3-2h24v24H-3z" />
        <g fill={props.fill ? props.fill : "#e3c1ac"} fillRule="nonzero">
          <path d="M15 6c-2.206 0-4 1.575-4 3.51v9.603c0 .489.454.887 1.011.887h5.978c.557 0 1.011-.398 1.011-.887V9.51C19 7.575 17.206 6 15 6zM7.353 13.584l-.218-5.911c-.023-.63-.482-1.161-1.081-1.316l.003-2.764c0-.45-.274-1.027-.627-1.316L2.872.183C2.723.062 2.574 0 2.429 0a.452.452 0 0 0-.378.2.712.712 0 0 0-.109.41l.006 5.747c-.6.154-1.06.685-1.084 1.316l-.218 5.911a.928.928 0 0 0-.646.877v4.614c0 .51.423.925.943.925h6.114c.52 0 .943-.415.943-.925v-4.614a.928.928 0 0 0-.647-.877zm-5.562-.047l.19-5.15a.611.611 0 0 1 .61-.576H5.41c.323 0 .597.26.61.576l.19 5.15H1.79z" />
        </g>
      </g>
    </svg>
  );
};

export { IconTreatments };
